export default __webpack_public_path__ + "static/s03-fd305f8feee1e01377faec9f7e11c050.png";